/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Modal,
  Typography,
  Row,
  Grid,
  Button,
  Form,
  DatePicker,
  Col,
} from 'antd';

import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { ESTATUS_AUTORIZADO, TIPO_MOVIMIENTO_BAJA, TIPO_MOVIMIENTO_CAMBIO } from 'utils/constants';
import { getMotivosDeLiquidaciones } from 'api/catalogos/motivosDeLiquidaciones';
import { getTiposAsignacion } from 'api/catalogos/TipoAsignacionDePlaza';
import { onError } from 'utils/handlers';
import { getLiquidaciones } from 'api/nominas/liquidaciones/liquidaciones';
import Select from './Select';

const { Text } = Typography;

const ModalUnAsignPlaza = ({
  onUnasign,
  onCancel,
  open,
  loading,
  form,
  rules,
  motivosMovimiento,
}) => {
  const screens = Grid.useBreakpoint();
  const nameFlag = 'es_baja';
  const [liquidaciones, setLiquidaciones] = useState([]);
  const [motivosLiquidaciones, setMotivosLiquidaciones] = useState([]);
  useEffect(() => {
    const loadCatalogs = async () => {
      try {
        const [
          _liquidaciones,
          _motivos_de_liquidaciones,
        ] = await Promise.all([
          getLiquidaciones(),
          getMotivosDeLiquidaciones({ estados_globales: ESTATUS_AUTORIZADO }),
        ]);
        setLiquidaciones(_liquidaciones);
        setMotivosLiquidaciones(_motivos_de_liquidaciones);
      } catch (err) {
        onError(err);
      }
    };
    loadCatalogs();
  }, []);
  return (
    <Modal
      title={(
        <Row justify="space-between">
          <Text>
            Desasignar Plaza
          </Text>
          <Row className="form-submit-controls">
            <Button
              type="link"
              onClick={onCancel}
              disabled={loading}
            >
              <ArrowLeftOutlined />
              {screens.md && 'Cancelar'}
            </Button>
            <Button
              type="link"
              onClick={onUnasign}
              disabled={loading}
              style={{ marginLeft: 10 }}
              className="submit-delete"
              autoFocus
            >
              <SaveOutlined />
              {screens.md && 'Guardar'}
            </Button>
          </Row>
        </Row>
      )}
      className="modal-delete"
      open={open}
      footer={null}
      closable={false}
      maskClosable={!loading}
      keyboard={!loading}
      destroyOnClose
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={() => onUnasign()}
        scrollToFirstError
      >
        <Form.Item
          allowClear
          name={nameFlag}
          label="¿Es Baja de Empleado?"
          rules={rules.required}
        // initialValue
        >
          <Select
            trueFalse
          />
        </Form.Item>
        <Form.Item shouldUpdate>
          {({ getFieldValue }) => {
            const flag = getFieldValue(nameFlag);
            const name_item_fecha = flag ? 'fecha_baja' : 'fecha_desasignacion';
            const name_item_select = flag ? 'motivo_desasignacion' : 'motivo_desasignacion';
            const label_item_fecha = flag ? 'Fecha de Baja' : 'Fecha de Desasignación de Plaza';
            const label_item_select = flag ? 'Motivo de Baja' : 'Motivo de Desasignación de Plaza';
            return (
              <>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    allowClear
                    name={name_item_fecha}
                    label={label_item_fecha}
                    rules={rules.required}
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      placeholder=""
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    allowClear
                    name={name_item_select}
                    label={label_item_select}
                    rules={rules.required}
                  >
                    <Select
                      dataSource={
                        // eslint-disable-next-line max-len
                        motivosMovimiento.filter((e) => e.tipos_de_movimientos_de_empleados === TIPO_MOVIMIENTO_BAJA
                          || e.tipos_de_movimientos_de_empleados === TIPO_MOVIMIENTO_CAMBIO)
                      }
                      render={(value) => `${value?.concepto}`}
                    />
                  </Form.Item>
                </Col>
                {flag && (
                  <>
                    <Col xs={24} sm={24} md={24}>
                      <Form.Item
                        allowClear
                        name="aplica_liquidacion"
                        label="¿Aplica Finiquito?"
                        rules={rules.required}
                      // initialValue
                      >
                        <Select
                          trueFalse
                        />
                      </Form.Item>
                    </Col>
                    {getFieldValue('aplica_liquidacion') && (
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          allowClear
                          name="liquidacion"
                          label="Tipo de Finiquito"
                          rules={rules.required}
                        >
                          <Select
                            dataSource={liquidaciones}
                            render={(value) => `${value?.clave} ${motivosLiquidaciones.find((motivo) => motivo.id === value?.motivo_de_liquidacion)?.motivo}`}
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </>
                )}
              </>
            );
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalUnAsignPlaza;
